export const TYPE_OPTIONS = [
  { value: "university", label: "University Open Day", color: "#BFDBFE" },
  { value: "apprenticeship", label: "Apprenticeship", color: "#BBF7D0" },
  { value: "employment", label: "Employment", color: "#FEF08A" },
  { value: "work_experience", label: "Work Experience", color: "#FBCFE8" },
  { value: "careers_fair", label: "Careers Fair", color: "#E9D5FF" },
  { value: "webinar", label: "Webinar", color: "#FFDED1" },
  { value: "other", label: "Other", color: "#E5E7EB" },
];

export const YEAR_OPTIONS = ["10", "11", "12", "13", "14"].map((y) => ({
  value: y,
  label: `Year ${y}`,
}));

export const typeLabel = (v) =>
  TYPE_OPTIONS.find((t) => t.value === v)?.label || v;

export const typeColor = (v) =>
  TYPE_OPTIONS.find((t) => t.value === v)?.color || "#E5E7EB";
